import { readContract } from 'viem/actions';
import { inboxABI } from '../constants/abis.js';
export async function getOrder({ client, inboxAddress, orderId, }) {
    return await readContract(client, {
        address: inboxAddress,
        abi: inboxABI,
        functionName: 'getOrder',
        args: [orderId],
    });
}
//# sourceMappingURL=getOrder.js.map